module.exports = __webpack_public_path__ + "img/razzo5.1e078a02.webp";